import TriStateProgressBar from '../TriStateProgressBar';
import styles from './AnnotatedTriStateProgressBar.scss';
import _ from 'lodash';
/* eslint-disable react/prop-types */ // TODO: add props

const validateAndSum = (...values) => {
  const isValid = _.every(values, (value) => !isNaN(value) && value >= 0);
  const total = isValid ? _.sum(values) : 0;
  return { isValid, total };
};

const AnnotatedTriStateProgressBar = ({
  nullCount,
  positiveCount,
  negativeCount,
  tooltipText = '',
  order,
  allowZero,
  children,
}) => {
  const { isValid, total } = validateAndSum(
    nullCount,
    positiveCount,
    negativeCount
  );

  return (
    <div
      title={isValid ? tooltipText : ''}
      className={styles.containerAnnotatedProgressBar}
    >
      <TriStateProgressBar
        nullCount={nullCount}
        positiveCount={positiveCount}
        negativeCount={negativeCount}
        order={order}
      />

      <div className={styles.progressBarAnnotation}>
        {allowZero && (total === 0 || total === nullCount) ? (
          <div className={styles.defaultText}>
            <span>{'0 '}</span> {'answered'}
          </div>
        ) : isValid && nullCount !== total ? (
          <>{children}</>
        ) : (
          <span>N/A</span>
        )}
      </div>
    </div>
  );
};

export default AnnotatedTriStateProgressBar;
